<template>
    <b-sidebar
        id="sidebar-bulk-send"
        sidebar-class="sidebar-lg"
        bg-variant="white"
        v-model="showBulkSidebar"
        shadow
        backdrop
        no-header
        right
    >
        <template #default="{ hide }">
            <!-- Header -->
            <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
                <h5 class="mb-0">
                    {{i18nT(`Send documents`)}}
                </h5>

                <feather-icon
                    class="ml-1 cursor-pointer"
                    icon="XIcon"
                    size="16"
                    @click="hide"
                />

            </div>

            <!-- Body -->
            <b-form
                class="p-2"
                @submit.prevent
            >

                <!-- From -->
                <b-form-group
                    :label="i18nT(`From`)"
                    label-for="from"
                >
                    <b-form-input
                        id="from"
                        v-model="sidebarForm.sender"
                        trim
                        type="email"
                    />
                </b-form-group>

                <!-- To -->
                <b-form-group
                    :label="i18nT(`To`)"
                    label-for="to"
                >
                    <b-form-input
                        id="to"
                        v-model="sidebarForm.receiver"
                        trim
                        type="text"
                    />
                </b-form-group>

                <b-form-group
                    :label="i18nT(`Message template`)"
                    label-for="message-template"
                >
                    <b-form-select
                        v-if="messageTemplates"
                        id="message-template"
                        v-model="message_template"
                        :options="messageTemplates"
                        trim></b-form-select>
                </b-form-group>

                <!-- Subject -->
                <b-form-group
                    :label="i18nT(`Subject`)"
                    label-for="subject"
                >
                    <b-form-input
                        id="subject"
                        v-model="sidebarForm.subject"
                        trim
                        type="text"
                    />
                </b-form-group>




                <!-- Message -->
                <b-form-group
                    :label="i18nT(`Message`)"
                    label-for="message"
                >
                    <b-form-textarea
                        id="message"
                        v-model="sidebarForm.message"
                        rows="12"
                        trim
                    />
                </b-form-group>


                <b-form-group
                    :label="i18nT(`Placeholder localization`)"
                    label-for="message-template"
                >
                    <b-form-select
                        v-if="cultures"
                        id="message-template"
                        v-model="sidebarForm.lang"
                        :options="cultures"
                        trim></b-form-select>
                </b-form-group>


                <b-form-group
                    :label="i18nT(`Zip Filename`)"
                    label-for="filename"
                >
                    <b-form-input
                        id="filename"
                        v-model="sidebarForm.attachmentFilename"
                        trim
                        type="text"
                    />
                </b-form-group>



                <div class="w-100 py-1">
                    <b-row>
                        <b-col cols="12">
                            <span>{{i18nT(`You can use the following placeholders in your invoice message`)}}:</span><br/>
                            <p class="pt-1"><em>[invoice_number], [invoice_amount], [company_name], [invoice_duedate], [invoice_link], [download_link]</em></p>
                            <span>
                        {{i18nT(`Set your default message in the settings for this software`)}} <b-link :to="`/ac/settings/invoice-messages`">{{i18nT(`by clicking here`)}}</b-link>
                    </span>
                        </b-col>
                    </b-row>
                </div>


                <!-- Form Actions -->
                <div class="d-flex mt-2">
                    <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="primary"
                        class="mr-2"
                        type="submit"
                        @click="sendInvoice"
                    >
                        {{i18nT(`Send`)}}
                    </b-button>
                    <b-button
                        v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                        variant="outline-secondary"
                        @click="hide"
                    >
                        {{i18nT(`Cancel`)}}
                    </b-button>
                </div>
            </b-form>
        </template>
    </b-sidebar>
</template>

<script>
import {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BButton,
    BFormSelect,
    BRow,
    BCol,
    BLink,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import store from "@/store";
import {useUtils as useI18Utils} from "@core/libs/i18n";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {dictToSelectArray} from "@core/utils/utils";
import useAuth from '@/auth/useAuth'

const {i18n} = useI18Utils();

export default {
    components: {
        BSidebar,
        BForm,
        BFormGroup,
        BFormInput,
        BFormTextarea,
        BButton,
        BFormSelect,
        BRow,
        BCol,
        BLink
    },
    directives: {
        Ripple,
    },
    data() {
        return {
            cultures: [],
            messageTemplates: null,
            message_template: '',
            showBulkSidebar: false,
            defaultMessage: i18n(`Dear Customer`)+`,

`+i18n(`Thank you for doing business with us, the invoice for the provided services can be found below!`)+`,

`+i18n(`Kind Regards`),
            formSubject: i18n(`Skileo documents`),
        }

    },
    mounted() {
        this.getCultures();
    },
    computed: {
        invoiceSet(){
            let stuff = store.getters['invoices/getInvoiceSet'];;
            console.log("Invoice set: ",stuff);
            return stuff;
        },
        sidebarForm() {
            let form = {
                invoice_ids: '',
                sender: '',
                receiver: '',
                subject: this.formSubject,
                message: this.defaultMessage,
                message_template: '',
                lang: 'en',
                attachmentFilename: i18n(`Skileo documents`),
            };

            form.invoice_ids = this.invoiceSet.join(',');

            let curWorkspace = useAuth.getCurWorkspace();

            if(curWorkspace){
                form.sender = curWorkspace.BusinessEmail;
                form.lang = curWorkspace.Language;
                form.subject = curWorkspace.Label +' '+ i18n(`Invoices `);
                form.attachmentFilename = curWorkspace.Label +' '+ i18n(`Invoices `);
            }

            return form;
        },
    },
    methods: {
        getCultures() {
            this.$http.get(`system/cultures`).then(({data}) => {
                this.cultures = dictToSelectArray(data.data)
            })
        },
        sendInvoice() {
            const formData = new FormData();
            for (const prop in this.sidebarForm) {
                if(this.sidebarForm[prop] === false) {
                    formData.append(prop, 0)
                    continue;
                } else {
                    formData.append(prop, this.sidebarForm[prop])
                }
            }
            this.$http.post('invoices/sendBulkInvoice', formData).then(response => {
                this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                        title: this.successMessage(response),
                        icon: "InfoIcon",
                        variant: "success",
                    },
                });
                this.$emit('sent');
                store.commit('invoices/SET_INVOICE_SET', []);
                this.showBulkSidebar = false;
            }).catch((err) => {
                this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                        title: this.errorMessage(err),
                        icon: "InfoIcon",
                        variant: "danger",
                    },
                });
            });

        }
    },
    watch: {
        message_template: function (val) {
            if(val){
                let message = this.messageTemplates.find((item) => item.value === val);
                this.defaultMessage = message.fullData.Message;
                this.formSubject = message.fullData.Subject;
            }
        },
        invoiceData: {
            handler: function (val) {
                if(val){
                    this.$http.get('invoices/invoiceMessages').then(response => {
                        this.messageTemplates = response.data.data.map((item) => {
                            return {value: item.Id, text: item.Label, fullData: item}
                        });
                        this.message_template = this.messageTemplates[0].value;
                        this.defaultMessage = response.data.data[0].Message;
                        this.formSubject = response.data.data[0].Subject;
                    });
                }
            },
            deep: true
        }
    }
}
</script>

<style>

</style>
